import { useCallback } from 'react';
import { useApiInstance } from './useApiInstance';
import { useAuth } from './useAuth';
import { EndpointsMvp } from './enum';
import { AbandonedCartNotifyState } from '../../store/ducks/abandoned-cart/types';

const useAbandonedCartService = () => {
  const commerceApi = useApiInstance();
  const { getHeaders } = useAuth();

  const notifyAbandonedCart = useCallback(
    async (
      quoteId: string,
      notification: AbandonedCartNotifyState
    ): Promise<boolean> => {
      if (
        quoteId.length === 0 ||
        quoteId.length > 15 ||
        isNaN(Number(quoteId))
      ) {
        console.error(
          '[AbandonedCart] quoteId inválido ou fora do limite seguro:',
          quoteId
        );
        return false;
      }

      const numericQuoteId = Number(quoteId);
      try {
        await commerceApi.post(
          EndpointsMvp.ABANDONED_CART_NOTIFY,
          {
            quote_id: numericQuoteId,
            notificated: JSON.stringify({
              notify_1: notification.notify1,
              notify_2: notification.notify2
            })
          },
          { headers: getHeaders({ withCommerceToken: true }) }
        );
        return true;
      } catch (err) {
        console.error('[AbandonedCart] notifyAbandonedCart failed:', err);
        return false;
      }
    },
    [commerceApi, getHeaders]
  );

  return { notifyAbandonedCart };
};

export default useAbandonedCartService;
